import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const formatPercent = (value) => `${Math.round(value * 100)}%`;

const CustomTooltip = ({ active, payload, label, chartType }) => {
  if (!active || !payload?.length) return null;

  const total = payload.reduce((sum, item) => {
    if (item.dataKey === 'Osszesen') return sum;
    return sum + Number(item.value ?? 0);
  }, 0);

  return (
    <div
      style={{
        background: '#615c5c',
        border: '1px solid #ddd',
        borderRadius: 12,
        padding: 12,
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
      }}
    >
      <strong>{label}</strong>

      {payload.map((item) => {
        const value = Number(item.value ?? 0);
        const percent = total > 0 ? Math.round((value / total) * 100) : 0;

        return (
          <div key={item.dataKey} style={{ marginTop: 6 }}>
            <span style={{ color: item.color }}>●</span> {item.name}:{' '}
            {chartType === 'percent' ? `${percent}%` : value}
          </div>
        );
      })}
    </div>
  );
};

const CapacityAreaChart = ({ data, chartType }) => {
  const isPercent = chartType === 'percent';
  const isStacked = chartType === 'stacked' || chartType === 'percent';

  return (
    <div style={{ width: '100%', height: 420 }}>
      <ResponsiveContainer>
        <AreaChart
          data={data}
          stackOffset={isPercent ? 'expand' : 'none'}
          margin={{ top: 16, right: 24, left: 0, bottom: 16 }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='Munkahet' />
          <YAxis tickFormatter={isPercent ? formatPercent : undefined} />

          <Tooltip content={<CustomTooltip chartType={chartType} />} />
          <Legend />

          <Area
            type='monotone'
            dataKey='Tanora'
            name='Megtartott'
            stackId={isStacked ? 'hours' : undefined}
            stroke='#79DB92'
            fill='#79DB92'
          />

          <Area
            type='monotone'
            dataKey='Lemondott'
            name='Lemondott'
            stackId={isStacked ? 'hours' : undefined}
            stroke='#ECD977'
            fill='#ECD977'
          />

          <Area
            type='monotone'
            dataKey='NemSzolt'
            name='Nem szólt'
            stackId={isStacked ? 'hours' : undefined}
            stroke='#EA8069'
            fill='#EA8069'
          />

          <Area
            type='monotone'
            dataKey='Torolt'
            name='Törölt'
            stackId={isStacked ? 'hours' : undefined}
            stroke='#93B7F3'
            fill='#93B7F3'
          />

          {!isPercent && (
            <Line
              type='monotone'
              dataKey='Osszesen'
              name='Összes tervezett óra'
              stroke='#6b71c3'
              dot={false}
              strokeWidth={2}
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CapacityAreaChart;
